import React, { memo } from 'react';

import PropTypes from 'prop-types';

import { FieldTypesEnum } from 'constants/loanActionEditor';

import { DynamicValueInput } from '../LoanActionItems';

import { groupOptionBySection } from './LoanActionEnterCustomFieldsRow.utils';

const LoanActionEnterCustomFieldsRow = ({
  index,
  rootPath,
  options,
  isDisabled = false,
  isEditAllowed,
}) => {
  const fieldPath = `${rootPath}[${index}]`;

  return (
    <DynamicValueInput
      required
      className="grow"
      disabled={isDisabled || !isEditAllowed}
      groupBy={groupOptionBySection}
      label="Custom Fields"
      name={`${fieldPath}.customFieldDefinitionIds`}
      options={options}
      type={FieldTypesEnum.MULTISELECT}
    />
  );
};

LoanActionEnterCustomFieldsRow.propTypes = {
  index: PropTypes.number.isRequired,
  rootPath: PropTypes.string.isRequired,
  options: PropTypes.array.isRequired,
  isEditAllowed: PropTypes.bool.isRequired,
  isDisabled: PropTypes.bool,
};

export default memo(LoanActionEnterCustomFieldsRow);
